package ru.chm.gradereport.ui.theme

import androidx.compose.runtime.compositionLocalOf

data class ThemeController(
    val mode: ThemeMode,
    val onModeChange: (ThemeMode) -> Unit,
)

val LocalThemeController = compositionLocalOf<ThemeController?> { null }
